
import { defineComponent, onMounted, reactive, computed } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { MenuComponent } from "@/assets/ts/components";
import mAxiosApi from "@/api";
import Users from "@/views/still/admin/users.vue"
import Actors from "@/views/still/admin/actors.vue"
import Tenants from "@/views/still/admin/tenants.vue"
import { ElNotification } from 'element-plus'

export default defineComponent({
  name: "customer-details",
  components: {
    Users,
    Actors,
    Tenants,
  },
 
  setup() {

    const state = reactive({
      loaderEnabled: true,
      lProducteurs: [] as any,
      lUsers: [] as any,
      lRoles: [] as any,
      drawer: false,
      drawer_morale: false,
      drawer_tenant: false,
      count: 0,
      countTenant: 0,
      paneBord : 1,
      zUser: {} as any,
      reloadlst : 1,
    });

    const modalActeur= reactive({
      act_n_seq: 0,
      act_c_raison_sociale: '',
      act_ark_n_type: '',
      act_c_categorie: '',
      act_c_status: '',
      act_c_mail: '',
      act_c_phone: '',
      act_c_adr: '',
      act_d_import: '',
      act_ark_c_nom2: '',
      act_ark_c_nom3: '',	
      act_ark_c_nom4: '',
      act_knum_responsable : '',
      act_ark_c_cp: '',
      act_ark_c_ville: '',
      act_ark_c_pays: ''
    });

    const modalUser= reactive({
      uti_n_seq: 0,
      uti_c_service: "",
      uti_c_phone: '',
      uti_c_mail: '',
      uti_knum_role: '',
      uti_c_prenom: '',
      uti_c_nom : '',
      uti_c_mess_instant : '',
      uti_c_status: '',
      producteur: [],
    });

    const modalTenant = reactive({
      code_ark: '',
      code_ark_edit: false,
      name: '',
      db_address: '',
      db_port: 3306,
      db_username: '',
      db_password: '',
      db_database: '',
      oidc_org_id: '',
    });

    onMounted(async () => {
      MenuComponent.reinitialization();

      setCurrentPageBreadcrumbs("Administration de l'application", []);

      let myListLiv = await getAxios("/getSVProducteur");
      state.lProducteurs = (myListLiv.results || []).map((p: any) => ({
        ...p,
        act_n_seq: parseInt(p.act_n_seq, 10),
      }));
      
      myListLiv = await getAxios("/getSVRoles");
      state.lRoles = myListLiv.results;

      const myListUsers = await getAxios("/getSVUsers");
      state.lUsers = myListUsers.results;

      state.lUsers.forEach(element => {
        if (element.producteur) {
          element.producteur = (typeof element.producteur === 'string'
            ? element.producteur.split(",")
            : element.producteur
          ).map(function(e: any){ return parseInt(e, 10); }).filter((e: any) => !isNaN(e));
        }
      });

      // console.log(state.lUsers);
      
      state.count =state.count + 1;
    });



    const resetModalUser = () => {
      modalUser.uti_n_seq = 0;
      modalUser.uti_c_service = "";
      modalUser.uti_c_phone = '';
      modalUser.uti_c_mail = '';
      modalUser.uti_knum_role = '';
      modalUser.uti_c_prenom = '';
      modalUser.uti_c_nom = '';
      modalUser.uti_c_mess_instant = '';
      modalUser.uti_c_status = '';
      modalUser.producteur = [];
    };

    const newUser = () => {
      resetModalUser();
      modalUser.uti_c_status = 'Compte actif';
      state.drawer = true;
    };

    const editUser = (d: any) => {
      modalUser.uti_n_seq = d.uti_n_seq;
      modalUser.uti_c_service = d.uti_c_service || "";
      modalUser.uti_c_phone = d.uti_c_phone || "";
      modalUser.uti_c_mail = d.uti_c_mail || "";
      modalUser.uti_knum_role = d.uti_knum_role || "";
      modalUser.uti_c_prenom = d.uti_c_prenom || "";
      modalUser.uti_c_nom = d.uti_c_nom || "";
      modalUser.uti_c_mess_instant = d.uti_c_mess_instant || "";
      modalUser.uti_c_status = d.uti_c_status || "";
      if (Array.isArray(d.producteur)) {
        modalUser.producteur = d.producteur
          .map((e: any) => parseInt(e, 10))
          .filter((e: any) => !isNaN(e));
      } else if (typeof d.producteur === "string" && d.producteur.trim()) {
        modalUser.producteur = d.producteur
          .split(",")
          .map((e: any) => parseInt(e, 10))
          .filter((e: any) => !isNaN(e));
      } else {
        modalUser.producteur = [];
      }
      state.drawer = true;
    };

    const getLengthProd = computed(() => {
      if (modalUser && modalUser.producteur) {
        return modalUser.producteur.length;
      }
      return 0;
    });

    const addEditUser = () => {
      if (!modalUser.uti_c_prenom) {
        ElNotification({ title: 'Erreur', message: 'Le champ Prénom est obligatoire', type: 'error' }); 
        return false;
      }
      if (!modalUser.uti_c_nom) {
        ElNotification({ title: 'Erreur', message: 'Le champ Nom est obligatoire', type: 'error' }); 
        return false;
      }
      if (!modalUser.uti_c_mail) {
        ElNotification({ title: 'Erreur', message: 'Le champ Email est obligatoire', type: 'error' }); 
        return false;
      }
      if (!modalUser.uti_knum_role) {
        ElNotification({ title: 'Erreur', message: 'Le champ Role est obligatoire', type: 'error' }); 
        return false;
      }

      mAxiosApi
        .post("/addEditUser", modalUser)
        .then(async () => {
          const mNotif = modalUser.uti_n_seq > 0 ? "Utilisateur modifié avec succès !" : "Utilisateur créé avec succès !";
          ElNotification({ title: 'Succès', message: mNotif, type: 'success' });
          state.drawer = false;
          resetModalUser();
          state.count = state.count + 1;
          const myListUsers = await getAxios("/getSVUsers");
          state.lUsers = myListUsers.results;
          state.lUsers.forEach((element: any) => {
            if (element.producteur) {
              element.producteur = (typeof element.producteur === 'string'
                ? element.producteur.split(",")
                : element.producteur
              ).map(function(e: any){ return parseInt(e, 10); }).filter((e: any) => !isNaN(e));
            }
          });
        })
        .catch((error: any) => {
          ElNotification({
            title: 'Erreur',
            message: error?.response?.data?.message || "Une erreur est survenue lors de l'enregistrement de l'utilisateur.",
            type: 'error',
          });
        });
    };
  
    const editPersMorale = (d) => {
      modalActeur.act_n_seq = d.act_n_seq;
      modalActeur.act_c_raison_sociale = d.act_c_raison_sociale;
      modalActeur.act_ark_n_type = d.act_ark_n_type;
      modalActeur.act_c_categorie = d.act_c_categorie;
      modalActeur.act_c_mail = d.act_c_mail;
      modalActeur.act_c_phone = d.act_c_phone;
      modalActeur.act_c_adr = d.act_c_adr;
      modalActeur.act_ark_c_nom2 = d.act_ark_c_nom2;
      modalActeur.act_ark_c_nom3 = d.act_ark_c_nom3;
      modalActeur.act_ark_c_nom4 = d.act_ark_c_nom4;
      modalActeur.act_knum_responsable = d.act_knum_responsable;

      state.drawer_morale = true;
    }

    const newPersMorale = () => {
      modalActeur.act_n_seq = 0;
      modalActeur.act_c_raison_sociale = "";
      modalActeur.act_ark_n_type = "";
      modalActeur.act_c_categorie = "";
      modalActeur.act_c_mail = "";
      modalActeur.act_c_phone = "";
      modalActeur.act_c_adr = "";
      modalActeur.act_ark_c_nom2 = "";
      modalActeur.act_ark_c_nom3 = "";
      modalActeur.act_ark_c_nom4 = "";
      modalActeur.act_knum_responsable = "";
      state.drawer_morale = true;
    }

    const addEditPersMorale = async () => {
      
      mAxiosApi
        .post("/addEditPersMorale", modalActeur)
        .then( async() => {
          const mNotif = modalActeur.act_n_seq > 0 ? "Acteur modifié avec succès !" : "Acteur créé avec succès !";
          ElNotification({ title: 'Succès', message: mNotif, type: 'success', })
          state.count = state.count + 1
          state.drawer_morale = false;
        })
    };

    const importJSON  = async() => {
      const jsonText = await navigator.clipboard.readText();
      try {
        let errorInJSON = false;
        try{
          let datas = JSON.parse(jsonText);

          if(!datas || !datas.act_c_raison_sociale) errorInJSON = true;

          if (!errorInJSON) {
            // if(datas.type == "")
            const responsable = datas.responsable ? state.lUsers.filter((el) => (el.uti_c_prenom + ' ' + el.uti_c_nom).toUpperCase() == datas.responsable.toUpperCase())[0].uti_n_seq : null
            const majType = datas.type.toUpperCase()
            let type = null as any
            if(majType == 'COLLECTIVITÉ') type = '1';
            if(majType == 'PERSONNE') type = '2';
            if(majType == 'FAMILLE') type = '3';

            modalActeur.act_c_raison_sociale = datas.act_c_raison_sociale
            modalActeur.act_ark_n_type = type
            modalActeur.act_c_categorie = datas.act_c_categorie
            modalActeur.act_c_mail = datas.act_c_mail
            modalActeur.act_c_phone = datas.act_c_phone
            modalActeur.act_c_adr = datas.act_c_adr
            modalActeur.act_ark_c_nom2 = datas.act_ark_c_nom2
            modalActeur.act_ark_c_nom3 = datas.act_ark_c_nom3
            modalActeur.act_ark_c_nom4 = datas.act_ark_c_nom4
            modalActeur.act_ark_c_ville = datas.act_ark_c_ville
            modalActeur.act_ark_c_cp = datas.act_ark_c_cp
            modalActeur.act_ark_c_pays = datas.act_ark_c_pays
            modalActeur.act_knum_responsable = responsable
          }

          } catch (er) {
          errorInJSON = true;
        }
        if (errorInJSON) {
          ElNotification({
            type: 'error',
            title: 'Erreur',
            message: 'Le JSON dans le presse papier est invalide.'
          })
        }
      } catch (error) {
        ElNotification({
          type: 'error',
          title: 'Erreur',
          message: 'Veuillez autoriser la lecture du presse papier dans les paramètres du site.'
        })
      }
    }

    const newTenant = () => {
      modalTenant.code_ark = '';
      modalTenant.code_ark_edit = false;
      modalTenant.name = '';
      modalTenant.db_address = '';
      modalTenant.db_port = 3306;
      modalTenant.db_username = '';
      modalTenant.db_password = '';
      modalTenant.db_database = '';
      modalTenant.oidc_org_id = '';
      state.drawer_tenant = true;
    }

    const editTenant = (d: any) => {
      modalTenant.code_ark = d.code_ark;
      modalTenant.code_ark_edit = true;
      modalTenant.name = d.name;
      modalTenant.db_address = d.db_address;
      modalTenant.db_port = d.db_port;
      modalTenant.db_username = d.db_username;
      modalTenant.db_password = '';
      modalTenant.db_database = d.db_database;
      modalTenant.oidc_org_id = d.oidc_org_id || '';
      state.drawer_tenant = true;
    }

    const addEditTenant = () => {
      if (!modalTenant.code_ark) {
        ElNotification({ title: 'Erreur', message: 'Le champ Code Ark est obligatoire', type: 'error' });
        return false;
      }
      if (!modalTenant.name) {
        ElNotification({ title: 'Erreur', message: 'Le champ Nom est obligatoire', type: 'error' });
        return false;
      }
      if (!modalTenant.db_address) {
        ElNotification({ title: 'Erreur', message: 'Le champ Adresse serveur est obligatoire', type: 'error' });
        return false;
      }
      if (!modalTenant.db_database) {
        ElNotification({ title: 'Erreur', message: 'Le champ Base de données est obligatoire', type: 'error' });
        return false;
      }

      mAxiosApi
        .post("/addEditTenant", modalTenant)
        .then(async () => {
          const mNotif = modalTenant.code_ark_edit ? "Tenant modifié avec succès !" : "Tenant créé avec succès !";
          ElNotification({ title: 'Succès', message: mNotif, type: 'success' })
          state.countTenant = state.countTenant + 1;
          state.drawer_tenant = false;
        })
    }

    return {
      state,
      modalActeur,
      editPersMorale,
      newPersMorale,
      addEditPersMorale,
      addEditUser,
      modalUser,
      newUser,
      editUser,
      resetModalUser,
      getLengthProd,
      importJSON,
      modalTenant,
      newTenant,
      editTenant,
      addEditTenant,
    }
  },
});

export async function getAxios(request: string): Promise<any> {
  const response = await mAxiosApi.get(request);
  return response.data;
}

